<template>
<el-dialog class="settings" title="설정" :visible.sync="visible" :append-to-body="true" fullscreen :modal="false" center :before-close="beforeClose">
  <nav class="settings-menu">
    <ul>
      <li v-for="item in menu" :key="item.id" :class="item.icon" @click="clickMenu(item)" >
        <span :class="['link',{ active: item.active }]">{{item.name}}</span>
      </li>
    </ul>
  </nav>
  <div class="main">
    <component :is="activeView" ref="activeView"></component>
  </div>
  <w-action-progress/>
</el-dialog>
</template>

<script>
import isEmpty from 'lodash/isEmpty';
import forEach from 'lodash/forEach';
import findIndex from 'lodash/findIndex';
import upperFirst from 'lodash/upperFirst';
import WActionProgress from '@/components/progressbar/ActionProgress';
import WServerSettings from './server';
import WNetworkSettings from './netdevice';
import WDatabaseSettings from './database';
import WVirtualSettings from './virtual';
import WOperationSettings from './operation';
import WLogSettings from './log';
import WApmSettings from './apm';
import WLogAnalysisSettings from './log-analysis';

import WBasicSettings from './basic';

export default {
  name: 'WSettings',
  components: {
    WServerSettings,
    WNetworkSettings,
    WDatabaseSettings,
    WBasicSettings,
    WOperationSettings,
    WLogSettings,
    WLogAnalysisSettings,
    WVirtualSettings,
    WApmSettings,
    WActionProgress,
  },
  data() {
    return {
      selectedMenu: {},
      visible: false,
      activeView: null,
      menu: [],
    };
  },
  computed: {
    settingMenuInfo() {
      return this.$store.getters.settingMenuInfo;
    },
    showSettingView() {
      return this.$store.getters.showSettingView;
    },
    autoMoveMenuInfo() {
      return this.$store.getters.autoMoveMenuInfo;
    },
  },
  watch: {
    settingMenuInfo: {
      immediate: true,
      handler(to) {
        if (!isEmpty(to)) {
          const menu = [];
          forEach(to, (item) => {
            menu.push({
              id: item.url,
              name: item.menuName,
              icon: item.menuIcon,
              active: false,
            });
          });
          this.menu = menu;
          this.clickMenu(this.menu[0]);
        }
      },
    },
    showSettingView: {
      immediate: true,
      handler(val) {
        if (val) {
          this.open();
        } else {
          this.close();
        }
      },
    },
    autoMoveMenuInfo: {
      immediate: true,
      handler(val) {
        if (!isEmpty(val)) {
          if (!this.showSettingView && val[0].id !== 'amsSlidingPopup') {
            this.$store.dispatch('showSettingView');
          }
          const index = findIndex(this.menu, (item) => item.id === val[0].id);
          if (index >= 0) {
            this.clickMenu(this.menu[index]);
          }
          if (val.length === 1) {
            this.$store.dispatch('setAutoMoveMenuInfo', null);
          }
        }
      },
    },
  },
  methods: {
    open() {
      this.visible = true;
      this.$store.dispatch('openFullScreenLayer');
      // this.$store.dispatch('showSettingView');
      this.clickMenu(this.menu[0]);
    },
    beforeClose() {
      this.$store.dispatch('closeSettingView');
    },
    close() {
      this.visible = false;
      this.$store.dispatch('closeFullScreenLayer');
    },
    /**
     * 클릭한 메뉴 기준으로 라우팅한다.
     * @author Ju
     * @param  {object} menu 클릭한 메뉴의 데이터 객체
     */
    clickMenu(menu) {
      if (isEmpty(this.selectedMenu)) {
        menu.active = true;
        this.selectedMenu = menu;
        this.activeView = `W${upperFirst(menu.id)}Settings`;
      } else if (this.selectedMenu.id === menu.id) {
        if (this.$refs.activeView) {
          this.$refs.activeView.clearActiveView();
        }
      } else {
        this.selectedMenu.active = false;
        menu.active = true;

        this.selectedMenu = menu;
        this.activeView = `W${upperFirst(menu.id)}Settings`;
      }
    },
  },
};
</script>

<style>
</style>



// WEBPACK FOOTER //
// src/views/settings/index.vue